export const editorialGallery = [
  {
    src: "assets/fashion/EditorialGallery1.jpg",
    alt: "Modelo posando"
  },
  {
    src: "assets/fashion/EditorialGallery2.jpg",
    alt: "Modelo en espacio interior"
  },
  {
    src: "assets/fashion/EditorialGallery6.jpg",
    alt: "Modelo con fondo y profundidad"
  },


  {
    src: "assets/fashion/EditorialGallery4.jpg",
    alt: "Fotografía creativa"
  },
  {
    src: "assets/fashion/EditorialGallery5.jpg",
    alt: "Primer plano modelo"
  },
  {
    src: "assets/fashion/EditorialGallery3.jpg",
    alt: "Modelo en espacio exterior"
  },
  {
    src: "assets/fashion/EditorialGallery7.jpg",
    alt: "Fotografía a través de ventana"
  },
  {
    src: "assets/fashion/EditorialGallery8.jpg",
    alt: "Foto espacio oscuro"
  },
  {
    src: "assets/fashion/EditorialGallery9.jpg",
    alt: "Fotografía diseño con modelo"
  }
];
